module.exports = __webpack_public_path__ + "static/media/mapathon_log.1ea444bf.svg";